import React, { useMemo } from 'react';
import { kebabCase } from '@/utils/strings';
import globalConfig from '@/config/general';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

const StyleVariables = _ref => {
  let {
    selector,
    data: srcStyles = {}
  } = _ref;
  const entries = Object.entries(srcStyles); // Trigger re-calculation of styles

  const updateKey = `${selector}-${entries.reduce((acc, _ref2) => {
    let [a, v] = _ref2;
    return `${acc}-${a}-${v}`;
  }, '')}`;
  const styles = useMemo(() => entries.reduce((acc, _ref3) => {
    let [attr, value] = _ref3;
    const varName = kebabCase(attr);

    if (value) {
      acc.push(`--${globalConfig.productNameSpace}-${varName}: ${value};`);
    }

    return acc;
  }, []), // eslint-disable-next-line react-hooks/exhaustive-deps
  [updateKey]);

  if (entries.length === 0) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }

  return /*#__PURE__*/_jsx("style", {
    children: `${selector} { ${styles.join(' ')} }`
  });
};

export default StyleVariables; // Scope attributes required to
// create a widget's style context

export function getWidgetAttr(widgetId) {
  return {
    'data-widget-style-ctx': `${widgetId}`
  };
} // Scope attributes required to
// create a layout's style context

export function getWidgetSectionCountAttr(sectionCount) {
  return {
    'data-widget-section-count': `${sectionCount}`
  };
} // Scope attributes required to
// create a widget's accreditation style context

export function getWidgetAccreditationAttr(visible) {
  return {
    'data-widget-accreditation-visible': `${visible}`
  };
} // Scope attributes required to
// create a layout's style context

export function getLayoutSectionCountAttr(sectionCount) {
  return {
    'data-layout-section-count': `${sectionCount}`
  };
} // Scope attributes required to
// create a layout grid's style context

export function getLayoutGridAttr(settings) {
  return {
    'data-grid-cell-max-height': `${settings.gridCellMaxHeight}`,
    'data-grid-max-columns': `${settings.gridMaxColumns}`
  };
} // Scope attributes required to
// create a section's style context

export function getSectionAttr(widgetId, sectionId) {
  return {
    'data-style-ctx': `${widgetId}-${sectionId}`
  };
} // Get the widget context style selector

export function getWidgetAttrSelector(widgetId) {
  return `[data-widget-style-ctx="${widgetId}"]`;
} // Get the layout section counter attribute

export function getLayoutSectionCounterAttrSelector(sectionCount) {
  return `[data-layout-section-count="${sectionCount}"]`;
} // Get the section context style selector

export function getSectionAttrSelector(widgetId, sectionId) {
  return `[data-style-ctx="${widgetId}-${sectionId}"]`;
} // Get computed section padding properties

export function getSectionPaddingProperties(widgetId, sectionId) {
  const el = document.querySelector(getSectionAttrSelector(widgetId, sectionId));
  if (!el) return null;
  const computedStyle = getComputedStyle(el);
  return {
    paddingTop: computedStyle.getPropertyValue(`--${globalConfig.productNameSpace}-padding-top`),
    paddingBottom: computedStyle.getPropertyValue(`--${globalConfig.productNameSpace}-padding-bottom`),
    paddingLeft: computedStyle.getPropertyValue(`--${globalConfig.productNameSpace}-padding-left`),
    paddingRight: computedStyle.getPropertyValue(`--${globalConfig.productNameSpace}-padding-right`)
  };
}